import { fetchWithToken } from "../../interceptors/fetchInterceptor";

import { MAIN_URL, PORT_FOR_TRAINING, API_GET_DATA_APPLICATION_TRAINING } from "../../constants/constants";

import { GET_DATA_BY_SEARCH_PARAMS_APPLICATION_TRAINING } from "../types";

export const getDataApplicationTrainingBySearchParams = (params, page) => {
  return async (dispatch) => {
    const response = await fetchWithToken(
      MAIN_URL + PORT_FOR_TRAINING + API_GET_DATA_APPLICATION_TRAINING + "page=" + page + "&size=10",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params),
      },
    ).catch((err) => console.log(err));
    if (response.ok) {
      const data = await response.json();
      dispatch({
        type: GET_DATA_BY_SEARCH_PARAMS_APPLICATION_TRAINING,
        data: data,
      });
    }
  };
};
